import styled, { css } from 'styled-components';

export const CommentsContent = styled.div`
  position: absolute;
  z-index: 999;
  //top: -420px;
  top: auto;
  bottom: 35px;
  right: 0;
  width: 600px;
  padding: 15px;
  background-color: ${(props) => (props.theme.theme === 'dark' ? '#393e44' : '#fff')};
  border-radius: 4px;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.5);
`;

export const CommentsBlock = styled.div`
  color: #8f8f8f;
  font-size: 12px;
  margin: 15px 0;
  padding: 10px 0;
  border-top: 1px solid #999;
  border-bottom: 1px solid #999;

  th {
    color: #000;
    padding: 5px !important;
    text-align: left;
  }
  td {
    color: #8f8f8f !important;
    padding: 5px !important;
    text-align: left;
    white-space: normal;
    max-width: 100%;
    div {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      th {
        color: #eee;
      }
      td {
        color: #ccc !important;
      }
    `}
`;

export const Comment = styled.tr``;
